import React from 'react';

const defaultStepStyle =
  'flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400';
const activeStepStyle =
  'flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold bg-indigo-500 text-white';

export default function Progress({ stepsNumber, step, goToStep }) {
  const steps = Array.from({ length: stepsNumber }, (_, i) => i);

  return (
    <div className="px-4 pt-12 pb-8">
      <div className="max-w-md mx-auto w-full">
        <div className="relative">
          <div
            className="absolute left-0 top-1/2 -mt-px w-full h-0.5 bg-slate-200 dark:bg-slate-700"
            aria-hidden="true"
          />
          <ul className="relative flex justify-between w-full">
            {steps.map((s) => (
              <li
                key={s}
                className={step === s ? activeStepStyle : defaultStepStyle}
              >
                <button
                  type="button"
                  className="w-full h-full"
                  onClick={() => goToStep(s)}
                >
                  {s + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
